import React, {Component} from 'react';
import {SketchPicker} from 'react-color';

import {Piano} from './Visualizer';

export default class CanvasFrame extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderTopBar() {
    const {
      background,
      onChangeCollapse,
      onClickDownloadImage,
      onChangeBackground,
      currentSketchName,
      brushName,
      onChangeBrush,
      p5State,
      sketches,
      onChangeSketch,
      onChangeSlider1,
      slider1Value,
    } = this.props;
    return (
      <div className="CanvasFrame__TopBar">
        <div className="VariableControls">
          <div className="CanvasFrame__Color">
            <div
              style={{
                backgroundColor: this.props.p5State.spectrumColor,
                height: '40px',
                width: '40px',
                border: 'solid 1px #999',
                borderRadius: '40px',
              }}
            />
          </div>
          <div>
            <Piano
              noteName={p5State.noteName}
              colors={this.props.colors}
              onChangeColors={this.props.onChangeColors}
            />
          </div>
        </div>
        <div className="FixedControls">
          <div style={{marginRight: 15}}>
            <button
              onClick={() => {
                this.setState({
                  pickingBackgroundColor: !this.state.pickingBackgroundColor,
                });
              }}
            >
              Escolher cor de fundo
            </button>
            {this.state.pickingBackgroundColor ? (
              <div style={{position: 'absolute'}}>
                <SketchPicker
                  color={background}
                  onChange={onChangeBackground}
                />
              </div>
            ) : null}
          </div>

          <div style={{marginRight: 15}}>
            <input
              name=""
              type="checkbox"
              checked={this.props.holdDraw}
              onChange={this.props.onToggleHoldDraw}
            />
          </div>

          <div>
            {p5State.slider1 && (
              <div>
                <input
                  onClick={e => e.stopPropagation()}
                  style={{marginRight: 15}}
                  name="slider1"
                  type="range"
                  value={slider1Value || 0}
                  min={p5State.slider1.min}
                  max={p5State.slider1.max}
                  onChange={onChangeSlider1}
                  step="1"
                />
              </div>
            )}
          </div>

          <div>
            <select
              onClick={e => e.stopPropagation()}
              style={{marginRight: '15px'}}
              label="Visualization"
              id=""
              name=""
              onChange={onChangeBrush}
              value={brushName}
            >
              <option value="Water Color">Aquarela</option>
              <option value="Circle">Círculo</option>
              <option value="Square">Quadrado</option>
            </select>
          </div>

          <div>
            <strong style={{marginRight: 15, color: 'white'}}>
              <a
                href="#"
                id="download"
                onClick={onClickDownloadImage}
                style={{color: 'white'}}
              >
                Baixar Imagem (beta)
              </a>
            </strong>
          </div>

          <div>
            <select
              onClick={e => e.stopPropagation()}
              style={{marginRight: '15px'}}
              onChange={onChangeSketch}
              value={currentSketchName}
            >
              {Object.keys(sketches).map((name, i) => (
                <option key={i} value={name}>
                  {name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  }

  renderControls() {}

  render() {
    return (
      <div className="CanvasFrame">
        <div className="CanvasFrame__Canvas">{this.props.children}</div>

        {this.props.collapsed ? null : this.renderTopBar()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CanvasFrame.js